import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "BaseTableHeaderSlider rounded-8 flex-1 q-py-sm overflow-hidden" }
const _hoisted_2 = { class: "row no-wrap items-center gap-12 q-py-sm" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "row no-wrap gap-12 items-center"
}

import { ref, Ref } from 'vue'

interface ISlide {
  id: number
  name: string
}

interface IProps {
  slideItems: ISlide[]
}

const scrollAmount = 250


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseTableHeaderSlider' },
  __name: 'BaseTableHeaderSlider',
  props: /*@__PURE__*/_mergeModels({
    slideItems: {}
  }, {
    "modelValue": { type: Number, required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel(__props, "modelValue")

const sliderRef: Ref<null | HTMLElement> = ref(null)
function scrollLeft() {
  if (sliderRef.value)
    sliderRef.value.scroll({
      left: sliderRef.value.scrollLeft - scrollAmount,
      behavior: 'smooth',
    })
}

function scrollRight() {
  if (sliderRef.value)
    sliderRef.value.scroll({
      left: sliderRef.value.scrollLeft + scrollAmount,
      behavior: 'smooth',
    })
}

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_k_circle_icon = _resolveComponent("k-circle-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "sliderRef",
        ref: sliderRef,
        class: "row no-wrap gap-12 items-center flex-1 overflow-auto hide-scrollbar"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slideItems, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["BaseTableHeaderSlider__title q-px-12 bg-cool-gray-30 cursor-pointer flex flex-center rounded-16 transition", model.value === item.id && 'BaseTableHeaderSlider__title--active bg-white']),
            onClick: ($event: any) => (model.value = item.id)
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["fs-13px fw-500 transition text-no-wrap", [model.value === item.id ? 'text-space-b-70' : 'text-cool-gray-80']])
            }, _toDisplayString(item.name), 3)
          ], 10, _hoisted_3))
        }), 128))
      ], 512),
      (sliderRef.value?.scrollWidth !== sliderRef.value?.offsetWidth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_q_separator, {
              vertical: "",
              color: "cool-gray-30",
              size: "2px",
              class: "BaseTableHeaderSlider__divider self-center"
            }),
            _createVNode(_component_k_circle_icon, {
              name: "arrow-left",
              color: "cool-gray-70",
              size: "20px",
              "is-hover": "",
              "root-class": "BaseTableHeaderSlider__controls flex flex-center cursor-pointer",
              onClick: scrollLeft
            }),
            _createVNode(_component_k_circle_icon, {
              name: "arrow-right",
              color: "cool-gray-70",
              size: "20px",
              "is-hover": "",
              "root-class": "BaseTableHeaderSlider__controls flex flex-center cursor-pointer",
              onClick: scrollRight
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})